export default __webpack_public_path__ + "static/media/usam.471ab05a.png";